export default [
  {
    name: "Scheduler Workers",
    path: "/scheduler-workers/workers",
    component: () => import("./pages/SchedulerWorkers"),
    meta: {
      ability: [
        {
          resource: "scheduler_workers",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Scheduler Workers Detaial",
    path: "/scheduler-workers/workers/:id",
    component: () => import("./pages/SchedulerWorkersDetails"),
    meta: {
      ability: [
        {
          resource: "scheduler_workers/:id",
          actions: ["read"],
        },
      ],
    },
  },
];
